import React from 'react';
import { motion } from 'framer-motion';
import { Gift, ShoppingCart, Coffee, Utensils, Zap, MapPin, Heart, Users, Video, Sparkles } from 'lucide-react';
export function BonusStack() {
  const bonusGroups = [{
    title: '🍽️ Tu Cocina Bajo Control',
    items: [{
      name: 'Plan de Menús de 4 Semanas',
      desc: '4 semanas de comidas planificadas. Abrís, seguís, cocinás. Sin pensar.',
      value: '$19.99',
      icon: <Utensils className="w-5 h-5" data-id="element-13" />
    }, {
      name: 'Lista de Compras Inteligente',
      desc: 'Llegás al super y sabés exactamente qué poner en el carrito.',
      value: '$9.99',
      icon: <ShoppingCart className="w-5 h-5" data-id="element-14" />
    }, {
      name: 'Desayunos Energéticos Sin Picos',
      desc: 'Empezá cada día con energía estable, no con un pico de glucosa.',
      value: '$14.99',
      icon: <Zap className="w-5 h-5" data-id="element-15" />
    }, {
      name: 'Bebidas y Licuados Aptos',
      desc: 'Opciones deliciosas que no sabotean tu control glucémico.',
      value: '$9.99',
      icon: <Coffee className="w-5 h-5" data-id="element-16" />
    }, {
      name: 'Snacks de Emergencia',
      desc: 'Para esos momentos de hambre urgente — opciones seguras y rápidas.',
      value: '$9.99',
      icon: <Sparkles className="w-5 h-5" data-id="element-17" />
    }]
  }, {
    title: '🌍 Tu Vida Social Sin Límites',
    items: [{
      name: 'Guía de Restaurantes (Comer Fuera)',
      desc: 'Pedí con confianza en cualquier restaurante. Sabé qué elegir y qué evitar.',
      value: '$14.99',
      icon: <MapPin className="w-5 h-5" data-id="element-18" />
    }, {
      name: 'Guía de Antojos y Ansiedad',
      desc: 'Estrategias reales para cuando el antojo golpea fuerte.',
      value: '$14.99',
      icon: <Heart className="w-5 h-5" data-id="element-19" />
    }, {
      name: 'Comidas para Fiestas y Eventos',
      desc: "Disfrutá de reuniones sin ser 'el/la de la dieta especial'.",
      value: '$12.99',
      icon: <Gift className="w-5 h-5" data-id="element-20" />
    }]
  }, {
    title: '🧠 Conocimiento Que Te Da Poder',
    items: [{
      name: 'Tabla de Índice Glucémico Fácil',
      desc: 'Consultá en segundos si un alimento es seguro para vos.',
      value: '$9.99',
      icon: <ClipboardListIcon className="w-5 h-5" data-id="element-21" />
    }, {
      name: 'Guía de Lectura de Etiquetas',
      desc: "Nunca más te engaña un paquete que dice 'light' o 'sin azúcar'.",
      value: '$12.99',
      icon: <SearchIcon className="w-5 h-5" data-id="element-22" />
    }, {
      name: 'Sustitutos de Azúcar y Harinas',
      desc: 'Seguí cocinando lo que te gusta, con ingredientes que te cuidan.',
      value: '$9.99',
      icon: <ChefHatIcon className="w-5 h-5" data-id="element-23" />
    }]
  }, {
    title: '⭐ Bonus Premium',
    highlight: true,
    items: [{
      name: 'Acceso a Comunidad de Apoyo',
      desc: 'No estás solo/a. Conectá con personas que entienden lo que vivís.',
      value: '$29.99',
      icon: <Users className="w-5 h-5" data-id="element-24" />
    }, {
      name: 'Masterclass: Entendiendo tu Glucosa',
      desc: 'Una clase que vale más que 10 consultas. Entendé de una vez cómo funciona tu cuerpo.',
      value: '$39.99',
      icon: <Video className="w-5 h-5" data-id="element-25" />
    }, {
      name: '🎁 Bonus Sorpresa (Recetario Especial)',
      desc: 'Un regalo extra que vas a amar. Lo descubrís cuando accedés.',
      value: '$19.99',
      icon: <Gift className="w-5 h-5" data-id="element-26" />
    }]
  }];
  return <section className="py-20 px-4 bg-[#FEFBF4]" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <div className="inline-flex items-center gap-2 bg-[#D97706]/10 text-[#D97706] px-4 py-2 rounded-full font-bold mb-4" data-id="element-30">
            <Gift className="w-5 h-5" data-id="element-31" />
            <span data-id="element-32">BONUS INCLUIDOS — Solo por tiempo limitado</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mb-4" data-id="element-33">
            14 Herramientas Extra Que Hacen Que Todo Funcione en Tu Vida Real
          </h2>
          <p className="text-lg text-[#1C1917]/70 max-w-3xl mx-auto" data-id="element-34">
            Las guías te dan el conocimiento. Los bonus te dan las herramientas
            para aplicarlo HOY — en tu cocina, en el supermercado, en un
            restaurante, en una fiesta.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-35">
          {bonusGroups.map((group, groupIndex) => <motion.div key={groupIndex} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: groupIndex * 0.1
        }} className={`rounded-2xl overflow-hidden ${group.highlight ? 'md:col-span-2 border-2 border-[#D97706] shadow-xl bg-white' : 'bg-white border border-[#1B4332]/10 shadow-lg'}`} data-id="element-36">
              <div className={`p-4 ${group.highlight ? 'bg-[#D97706]' : 'bg-[#1B4332]'} text-white font-bold text-lg flex items-center gap-2`} data-id="element-37">
                {group.title}
              </div>
              <div className={`p-6 ${group.highlight ? 'grid md:grid-cols-3 gap-6' : 'space-y-6'}`} data-id="element-38">
                {group.items.map((item, itemIndex) => <div key={itemIndex} className="flex gap-4" data-id="element-39">
                    <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${group.highlight ? 'bg-[#D97706]/10 text-[#D97706]' : 'bg-[#1B4332]/10 text-[#1B4332]'}`} data-id="element-40">
                      {item.icon}
                    </div>
                    <div data-id="element-41">
                      <h4 className="font-bold text-[#1C1917]" data-id="element-42">{item.name}</h4>
                      <p className="text-sm text-[#1C1917]/70 mb-1" data-id="element-43">
                        {item.desc}
                      </p>
                      <p className="text-xs font-semibold text-[#D97706]" data-id="element-44">
                        Valor: {item.value}
                      </p>
                    </div>
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center space-y-2" data-id="element-45">
          <p className="text-lg text-[#1C1917]/60" data-id="element-46">
            Valor total de los bonus:{' '}
            <span className="line-through" data-id="element-47">$230.85</span>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[#1B4332]" data-id="element-48">
            Valor total del pack completo:{' '}
            <span className="line-through text-[#D97706]" data-id="element-49">$315.82</span>
          </p>
        </div>
      </div>
    </section>;
}
// Helper icons for this file only to avoid import errors if lucide doesn't export them exactly as named
function ClipboardListIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-50">
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" data-id="element-51" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" data-id="element-52" />
      <path d="M12 11h4" data-id="element-53" />
      <path d="M12 16h4" data-id="element-54" />
      <path d="M8 11h.01" data-id="element-55" />
      <path d="M8 16h.01" data-id="element-56" />
    </svg>;
}
function SearchIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-57">
      <circle cx="11" cy="11" r="8" data-id="element-58" />
      <path d="m21 21-4.3-4.3" data-id="element-59" />
    </svg>;
}
function ChefHatIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-60">
      <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" data-id="element-61" />
      <line x1="6" x2="18" y1="17" y2="17" data-id="element-62" />
    </svg>;
}